import { useAnalytics } from '@app/features/analytics/hooks/use-analytics';
import React from 'react';

import { InterHeaderStyles } from '../../styles';
import { navigateToEvent } from '../../utils';
import { EventType } from './types';

export const EventNameTemplate = ({ data }: { data: EventType }) => {
  const { track } = useAnalytics();
  return (
    <div className="flex items-start">
      <img
        className="rounded-md h-[32px] w-14 min-w-14 mr-4"
        src={data.eventBannerUrl}
        alt=""
      />

      <button
        className="break-words my-auto block truncate max-w-64"
        onClick={() => {
          navigateToEvent(data.slug);
          track('ola_events_tab_individual_event_click', {
            eventSlug: data.slug,
            eventName: data.name,
          });
        }}
      >
        <span title={data.name} className={InterHeaderStyles}>
          {data.name}
        </span>
      </button>
    </div>
  );
};
